/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
          $('ul.nav a.subscribe').on('click',function(){
            ga('send', {
              hitType: 'event',
                  eventCategory: 'Newsletter',
                  eventAction: 'Clicked Subscribe In Nav',
                  eventLabel: 'Newsletter Subscribe form opened'
            });
            $(document).bind("gform_confirmation_loaded", function (e, form_id) {
              // code to run upon successful form submission
              ga('send', {
                hitType: 'event',
                    eventCategory: 'Newsletter',
                    eventAction: 'Clicked Subscribe',
                    eventLabel: 'Newsletter Subscribe clicked'
              });
            });
          });


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    'tag':{
      init: function() {
        $('.mobile-topics').on('click',function(){
          $('#lgbox').fadeIn('slow');
        });
        $('#lgbox .close,#lgbox .shader').on('click',function(){
          $('#lgbox').fadeOut('slow');
        });
      }
    },
    'page_faq':{
      init: function(){
        $('li.question .clickable').on('click',function(){
          $(this)
            .parent()
            .siblings()
            .removeClass('active')
            .end()
            .toggleClass('active');
          // Auto scroll only if on small width device
          var w = $(window).width();
          if(w <= 991){
            $('html,body').animate({
              scrollTop: $('li.question.active').offset().top - 70 },
            'slow');
          }
        });
      }
    },
    'page_contact_us':{
      init: function(){
            // Begin each dropdown
            $('.gform select').each(function () {
              var placeH = $(this).attr("placeholder");
                $(this).select2({
                    minimumResultsForSearch: Infinity,
                    placeholder: placeH
                });
            });
            $('b[role="presentation"]').hide();
            $('.select2-selection__arrow').append('<i class="fa fa-angle-down"></i>');

            // $('.gform select').each(function(){
            //     $(this).on('select2:open', function (e) {
            //       var container = $(this).select('select2-container');
            //       var position = container.offset().top;
            //       var availableHeight = $(window).height() - position - container.outerHeight();
            //       var bottomPadding = 50; // Set as needed
            //       // $('ul.select2-results__options').css('max-height', (availableHeight - bottomPadding) + 'px');
            //     });
            // });

            // Begin assets var
            var ASSETS = {};
            ASSETS.process_url = '/contact-us/submit/';

              // Begin validator defaults
              $.validator.setDefaults({
                ignore: [],
                submitHandler: function(e){
                  $.ajax({
                      url: ASSETS.process_url,
                      dataType: "text",
                      type: 'POST',
                      data: $('form.gform').serialize(),
                      success: function( data, statusText, jQxhr ){
                        // Do not fade out form
                        // $('form').fadeOut('slow',function(){ });

                          $('form.gform').find('.summary').hide().html("Thanks – your message has been received. We will contact you shortly.").fadeIn();
                          setTimeout(function(){
                            $('form.gform').trigger('reset');
                          },1500);
                          setTimeout(function(){
                          $('form.gform').find('.summary').hide().html("").fadeIn();
                          },7000);
                      },
                      error: function( response, statusText){
                        // @gk Suppressing Error Messages For Now
                        // var err;
                        // err = $.parseJSON(response.responseText);
                        try {
                            // err = $.parseJSON(response.responseText);
                            // alert(err.Message);
                        } catch(e) {
                            // alert("ERROR:\n" + response.responseText);
                          // window.alert('Something went wrong. Please try again on a different device. Error in routine data (Err_09)');
                        }
                          // alert(err.Message);
                          // window.console.log($('form.gform').serialize());
                          // window.console.log('Failed ' + response.status + ' ' + response.statusText);
                          // window.console.log('statusText');
                          $('form.gform').find('.summary').hide().html("Thanks – your message has been received. We will contact you shortly.").fadeIn();
                          setTimeout(function(){
                            $('form.gform').trigger('reset');
                          },1500);
                          setTimeout(function(){
                          $('form.gform').find('.summary').hide().html("").fadeIn();
                          },7000);
                      }
                  });
                }
              });

              // Begin validator validEmail method
              $.validator.addMethod("validEmail", function(value, element)
              {
                  if(value === '')
                      return true;
                  var temp1;
                  temp1 = true;
                  var ind = value.indexOf('@');
                  var str2=value.substr(ind+1);
                  var str3=str2.substr(0,str2.indexOf('.'));
                  if(str3.lastIndexOf('-')==(str3.length-1)||(str3.indexOf('-')!=str3.lastIndexOf('-')))
                      return false;
                  var str1=value.substr(0,ind);
                  if((str1.lastIndexOf('_')==(str1.length-1))||(str1.lastIndexOf('.')==(str1.length-1))||(str1.lastIndexOf('-')==(str1.length-1)))
                      return false;
                  str = /(^[a-zA-Z0-9]+[\._-]{0,1})+([a-zA-Z0-9]+[_]{0,1})*@([a-zA-Z0-9]+[-]{0,1})+(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,5})$/;
                  temp1 = str.test(value);
                  return temp1;
              }, "Please enter valid email.");

              window.console.log('gform validator settings');
              var validator = $('form.gform').each(function(){
               $(this).bind("invalid-form.validate", function() {
                if($(this).closest('form').hasClass('contact')){
                  $(this).find('.summary').html("Your form contains errors, please fill in all required fields.");
                }else{
                  $(this).find('.summary').html("Your form contains errors, please fill in all required fields.");
                }
              }).validate({
                  debug: true,
                  errorContainer: $(this).find('.summary'),
                  errorElement: "span",
                  errorPlacement: function(error, element) {
                    if (element.is(":radio"))
                      error.appendTo(element.parent().next().next());
                    else if (element.is(":checkbox"))
                      error.appendTo(element.parent("div"));
                    else
                       element.addClass('error');
                      error.appendTo(element.parent("div"));
                  },
                  success: function(label) {
                    label.remove();
                  },
                  highlight: function(element, errorClass) {
                    $(element).parent().next().find("." + errorClass).removeClass("checked");
                  },
                  messages: {
                    email: { required: 'Enter Your Email' },
                  },rules: {
                    email: {
                      required: true,
                      validEmail: true
                    }
                  }
                });
              });

              $('.button.submit').click(function(e){
                $('form.gform input').removeClass('error');
                $(this).closest('form').submit();
                return false;
              });

      }
    },
    'page_about_cacique':{
      init: function(){

        $('.scrollto').on('click',function(e){
              var target = $(this.hash);
              // target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
              if (target.length) {
                $('html, body').animate({
                  scrollTop: target.offset().top
                }, 300);
              }
        });

      }
    },
    'page_blog':{
      init: function(){
        $('.mobile-topics').on('click',function(){
          $('#lgbox').fadeIn('slow');
        });
        $('#lgbox .close,#lgbox .shader').on('click',function(){
          $('#lgbox').fadeOut('slow');
        });
      }
    },
    'search':{
      init: function() {

          var $slider = $('.blog-slider');
          $slider.on("init.slick", function (event, slick) {
              // $slider.css({border: "4px solid red"});
              setTimeout(function(){
                  // Add arrows to the dots nav row
                  // jQuery('.slick-dots').wrap(function() {
                  //   return "<div class='slickdotholder'></div>";
                  // })
                  // jQuery('.slickdotholder').prepend('<div style="position:absolute; top: 10px;width:13px;"><img class="slick-prev" src="/wp-content/themes/cacique/assets/images/blog-slider-prev.png"></div>');
                  // jQuery('.slickdotholder').append('<div style="position:absolute; top: 10px;width:13px;"><img class="slick-next" src="/wp-content/themes/cacique/assets/images/blog-slider-next.png"></div>');

                  // jQuery('.slick-prev, .slick-next').off();
              },500);
          });

          $slider.slick({
              infinite: false,
              dots: true,
              slidesToShow: 3,
              slidesToScroll: 3,
              autoplay: true,
              autoplaySpeed: 7500,
              arrows: false,
              responsive: [
                  {
                      breakpoint: 992,
                      settings: {
                          dots: false
                      }
                  }
              ]
          });

          // jQuery('.slick-dots').prepend('<li style="top: 10px;width:13px;"><img class="slick-prev" src="/wp-content/themes/cacique/assets/images/blog-slider-prev.png"></li>');
          // jQuery('.slick-dots').append('<li style="top: 10px;width:13px;"><img class="slick-next" src="/wp-content/themes/cacique/assets/images/blog-slider-next.png"></li>');
          // jQuery('.slick-prev, .slick-next').off();

          $('.slick-prev').click(function () {
             $slider.slick('slickPrev');
          });

          $('.slick-next').click(function () {
              $slider.slick('slickNext');
          });


        $('a.view-more-products').on('click', function(e) {
            e.preventDefault();
            $('.product-category-products-row > .product-category-products-row').remove();
            $(this).addClass('loading').text('Loading');
            $.ajax({
                type: "GET",
                url: $(this).attr('href'),
                dataType: "html",
                success: function(status) {
                    result = $(status).find( '.product-category-products-row' );
                    result.unwrap();
                    $('.product-category-products-row').append(result.fadeIn(300));
                    $('a.view-more-products').removeClass('loading').hide().text('View More Product Results');
                    $('a.view-less-products').hide().fadeIn();

                    $('a.view-less-products').on('click',function(){
                      $('.additional-product-items').each(function(){
                        $(this).fadeOut();
                      });
                      $(this).hide();
                      $('.product-category-products-row > .product-category-products-row').remove();
                      $('a.view-more-products').fadeIn();
                    });
                }
            });
        });

        $('a.view-more-recipes').on('click', function(e) {
            e.preventDefault();
            $('.recipes-row > .recipes-row').remove();
            $(this).addClass('loading').text('Loading');
            $.ajax({
                type: "GET",
                url: $(this).attr('href'),
                dataType: "html",
                success: function(status) {

                  var html = $.parseHTML(status);
                  result = $(html).find( '.recipes-row' );
                  result.unwrap();

                  $('.recipes-row').append(result.fadeIn(300));
                  $('a.view-more-recipes').removeClass('loading').hide().text('View More Recipe Results');
                  $('a.view-less-recipes').hide().fadeIn();

                  $('a.view-less-recipes').on('click',function(){
                    $('.additional-recipe-items').each(function(){
                      $(this).fadeOut();
                    });
                    $(this).hide();
                    $('.recipes-row > .recipes-row').remove();
                    $('a.view-more-recipes').fadeIn();
                  });
                }
            });
        });


        $('a.view-more-posts').on('click', function(e) {
            e.preventDefault();
            $('.blog-holder > .blog-slider').remove();
            $(this).addClass('loading').text('Loading');
            $.ajax({
                type: "GET",
                url: $(this).attr('href'),
                dataType: "html",
                success: function(status) {
                  var html = $.parseHTML(status);
                    result = $(html).find( '.blog-slider' );
                    $('.blog-holder').append(result.fadeIn(300));
                    $('a.view-more-posts').removeClass('loading').hide().text('View More Recipe Results');
                    $('a.view-less-posts').hide().fadeIn();

                    $slider.slick('removeSlide', null, null, true);

                    $('.blog-holder .additional-posts').each(function(){
                      // slideIndex++;
                      $slider.slick('slickAdd',$(this));
                    });
                      // $('.add-remove').slick('slickAdd','<div><h3>' + slideIndex + '</h3></div>');

                    // $('a.view-less-posts').on('click',function(){
                    //   $('.additional-recipe-items').each(function(){
                    //     $(this).fadeOut();
                    //   });
                    //   $(this).hide();
                    //   $('.blog-holder > .blog-slider').remove();
                    //   $('a.view-more-posts').fadeIn();
                    // });
                }
            });
        });


        // @gk obs
        // $('.product-category-all').readmore({
        //   collapsedHeight: $('.product-category-all .cacique-product:eq(0)').height() * 2 ,// 735,
        //   speed: 75,
        //   moreLink: '<a class="readmore viewmore" href="#">view all results</a>',
        //   lessLink: '<a class="readmore lessing" href="#">Show Less</a>'
        // });

        // @gk obs
        // $('.row.results').readmore({
        //   collapsedHeight: $('.row.results .recipe-single-recipe:eq(0)').height() * 2 ,// 387,
        //   speed: 75,
        //   moreLink: '<a class="readmore viewmore" href="#">view all results</a>',
        //   lessLink: '<a class="readmore lessing" href="#">show less</a>'
        // });

        // @gk obs
        // $('.mobile-blog-results').readmore({
        //   collapsedHeight: $('.blog-search > a:eq(0)').height() * 2 ,// 387,
        //   speed: 75,
        //   moreLink: '<a class="readmore viewmore" href="#">view all results</a>',
        //   lessLink: '<a class="readmore lessing" href="#">show less</a>'
        // });

        // DISABLED
        // $('.site-results').readmore({
        //   collapsedHeight: .height() * 2 ,// 500,
        //   speed: 75,
        //   moreLink: '<a class="readmore viewmore" href="#">view all results</a>',
        //   lessLink: '<a class="readmore lessing" href="#">show less</a>'
        // });
      }
    },
    'home': {
      init: function() {
      // Home page
      /* HOME SLIDER EXPERIENCE TEMPORARY HOLDING */
              var bannerIndex = 0;
              var bannerPosition = 0;
              var bannerLock = false;
              var bannerCount = 0;

          function init() {
            $(window).bind('resize', update);
            var autoNextBanner = setInterval(nextBanner, 7500);
            $('#home-banner').on('click',function(){
              clearInterval(autoNextBanner);
            });
            $('#home-banner .banner-nav-left').click(prevBanner);
            $('#home-banner .banner-nav-right').click(nextBanner);
            $('#home-banner .banner-nav-bullet').click(bulletClick);
            bannerCount = $('#home-banner .banner').length;
          }

          function bulletClick() {
            var index = $(this).index();
            var active = $('#home-banner .banner-nav-bullet.active').index();
            var delta = index - active;
            if( delta < 0 ) {
              prevBanner(Math.abs(delta));
            } else if( 0 < delta ) {
              nextBanner(Math.abs(delta));
            }
          }

          function prevBanner(step) {
            if( !bannerLock ) {
              bannerLock = true;
              var $container = $('#home-banner .banner-container');
              var pos = $container.position();
              var left = pos.left;
              bannerPosition--;
              if( bannerPosition < 0 ) bannerPosition = bannerCount - 1;
              if( bannerIndex == 0 ) {
                $container.find('.banner:last-child').prependTo($container);
                $container.css({left: (left - $(window).width())});
              } else {
                bannerIndex--;
                left += $(window).width();
              }
              updateBannerBullets();
              var ease = 0 < step ? 'linear' : 'swing';
              $container.animate({left: left}, 550, ease, function() {
                bannerLock = false;
                if( 1 < step ) prevBanner(step-1);
              });
            }
          }

          function nextBanner(step) {
            if( !bannerLock ) {
              bannerLock = true;
              var $container = $('#home-banner .banner-container');
              var pos = $container.position();
              var left = pos.left;
              bannerPosition++;
              if( bannerCount <= bannerPosition ) bannerPosition = 0;
              if( bannerIndex == bannerCount - 1 ) {
                $container.find('.banner:first-child').appendTo($container);
                $container.css({left: (left + $(window).width())});
              } else {
                bannerIndex++;
                left -= $(window).width();
              }
              updateBannerBullets();
              var ease = 0 < step ? 'linear' : 'swing';
              $container.animate({left: left}, 550, ease, function() {
                bannerLock = false;
                if( 1 < step ) nextBanner(step-1);
              });
            }
          }

          function update() {
            updateBanner();
            updateBannerBullets();
            updateCategories();
          }

          function updateBanner() {
            var $container = $('#home-banner .banner-container');
            $container.css({left: (-1 * bannerIndex * $(window).width())});
            $('.banner-image img').each(function(index, element) {
              var $el = $(element);
              if( $(window).width() < 992 ) {
                $el.css('marginTop', 0);
              } else {
                $el.css('marginTop', ($el.height() / -2));
              }
            });
          }

          function updateBannerBullets() {
            $('.banner-nav-bullet.active').removeClass('active');
            $('.banner-nav-bullet').eq(bannerPosition).addClass('active');
          }

          function updateCategories() {
            $('.product-category-image img').each(function(index, element) {
              var $el = $(element);
              $el.css('marginLeft', ($el.width() / -2));
            });
          }

          $(document).ready(init);
          $(window).load(update);
          $('.mobile-recipe-title').each(function(){
            $(this).readmore({
              collapsedHeight: 65,
              speed: 75,
              moreLink: '',
              lessLink: ''
            });
          });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'single_post': {
      init: function() {
        // $('#lightgallery_preview img').fakecrop({
        //   wrapperWidth : 180,
        //   wrapperHeight : 180
        // });
        var win_width = $(window).width();
        if( win_width >= 768 ){
          $('#lightgallery_preview li').nailthumb({
            width:180,
            height:180,
            titleAttr:false
          });
        }else{
          $('#lightgallery_preview li').nailthumb({
            width:120,
            height:120,
            titleAttr:false
          });
        }

        // Galleria.run('#lightgallery',{width:900,height:500});

        // $('#lightgallery').galleria();


        //essentially what you had above
        document.onkeyup = KeyCheck;
        function KeyCheck(e) {
            var KeyID = (window.event) ? event.keyCode : e.keyCode;
            switch(KeyID) {
                case 37: //press left arrow
                    gallery.prev();
                    break;
                case 39: //press right arrow
                    gallery.next();
                    break;
            }
        }
        $('#lightgallery img').each(function(){
          $(this).css('opacity',0);
        });
        $('#lightgallery_preview li').each(function(){
          $(this).on('click',function(){
            var activeInt = $(this).data('int'),
                selectedIndex=activeInt;
            if($('#lightgallery_preview').hasClass('gactivated')){
              var gallery = Galleria.get(0);
              Galleria.ready(function() { //Attempt to show the same indexed image in the galleria
                  var gallery = this;
                  gallery.show( activeInt );
                  $('#lgbox').fadeIn('slow');
              });
            }else{
              $('#lgbox').hide().fadeIn('slow',function(){
                Galleria.run('#lightgallery');
                Galleria.configure({
                    show: selectedIndex,
                    // thumbCrop:"width",
                    width:1000,
                    height:700,
                    imageMargin: 35,
                    transition: 'fade',
                    // showInfo: false,
                    // autoplay: 4000,
                    lightbox: false,
                    showImagenav: true,
                    imageCrop: false,
                    thumbnails: true
                });
                Galleria.ready(function() {
                  $('#lightgallery img').each(function(){
                    $(this).css('opacity',1);
                  });
                });
                // var gallery = Galleria.get(0);
                // Galleria.ready(function() { //Attempt to show the same indexed image in the galleria
                //     var gallery = this;
                //     selectedIndex = activeInt;
                //     // gallery.show( activeInt );
                // });
              });
              $('#lightgallery_preview').addClass('gactivated');
            }
            $('#lgbox .close,#lgbox .shader').on('click',function(){
              $('#lgbox').fadeOut('slow');
            });
          });
        });
        // SAMPLE CODE ONLY - GALLERIA JUMP TO AN IMAGE
        // $('.test_02').on('click',function(){
        //     //obtain galleria instance - this might be the step you are missing
        //     var gallery = Galleria.get(0);
        //     Galleria.ready(function() { //Attempt to show the same indexed image in the galleria
        //         var gallery = this;
        //         selectedIndex=1;
        //         gallery.show(1);
        //     });
        // });
      }
    },
    'single_products': {
      init: function(){
        if( $('.products-single-video img').is(':visible') ){
          $('.products-single-video img').on('click',function(){
            $(this).hide();
            $('#main-video').show();
          });
        }
      }
    },
    'page_careers': {
      init: function(){

        var offset = $(".stickyplaceholder").offset();
        $(".stickyplaceholder > nav").affix({
            offset: {
                top: offset.top
            }
        });

        var dropdownoffset = $(".dropdown.selector").offset();
        $(".dropdown.selector > .row").affix({
            offset: {
                top: dropdownoffset.top
            }
        });

        $('#jumpselect').bind('change', function () {
          $("html, body").animate({
            scrollTop: $('#' + $(this).val()).offset().top - 50
          }, "slow");
          // alert($('#' + $(this).val()).html());
        });


        $(window).scroll(function(){
          // @debug
          // window.console.log('[scrolling - current]:::: ' + $(document).scrollTop());
          // window.console.log('location: ' + $('#location').position().top);
          // window.console.log('sustainability: ' + $('#sustainability').position().top);
          // window.console.log('training: ' + $('#training').position().top);
          // window.console.log('benefits: ' + $('#benefits').position().top);
          // window.console.log('talentnetwork: ' + $('#talentnetwork').position().top);
          // window.console.log('mission: ' + $('#mission').position().top);
          // window.console.log('opportunities: ' + $('#opportunities').position().top);


          // if ( $(document).scrollTop() > ( $('#family').position().top - 35 ) ) {
          //     $('nav ul li a').removeClass('active');
          //     $('nav a[href=#family]').addClass('active');
          //     $(".careersNav").trigger('to.owl.carousel', 7);
          // } else
          if ( $(document).scrollTop() > ( $('#location').position().top - 35 ) ) {
              $('nav ul li a').removeClass('active');
              $('nav a[href=#location]').addClass('active');
              $(".careersNav").trigger('to.owl.carousel', 6);
          } else if ( $(document).scrollTop() > ( $('#sustainability').position().top - 35 ) ) {
              $('nav ul li a').removeClass('active');
              $('nav a[href=#sustainability]').addClass('active');
              $(".careersNav").trigger('to.owl.carousel', 5);
          } else if ( $(document).scrollTop() > ( $('#training').position().top - 35 ) ) {
              $('nav ul li a').removeClass('active');
              $('nav a[href=#training]').addClass('active');
              $(".careersNav").trigger('to.owl.carousel', 4);
          } else if ( $(document).scrollTop() > ( $('#benefits').position().top - 35 ) ) {
              $('nav ul li a').removeClass('active');
              $('nav a[href=#benefits]').addClass('active');
              $(".careersNav").trigger('to.owl.carousel', 3);
          } else if ( $(document).scrollTop() > ( $('#talentnetwork').position().top - 35 ) ) {
              $('nav ul li a').removeClass('active');
              $('nav a[href=#talentnetwork]').addClass('active');
              $(".careersNav").trigger('to.owl.carousel', 2);
          } else if ( $(document).scrollTop() > ( $('#mission').position().top - 35 ) ) {
              $('nav ul li a').removeClass('active');
              $('nav a[href=#mission]').addClass('active');
              $(".careersNav").trigger('to.owl.carousel', 1);
          } else if ($(document).scrollTop() > ( $('#opportunities').position().top - 35 ) ) {
              $('nav ul li a').removeClass('active');
              $('nav a[href=#opportunities]').addClass('active');
              $(".careersNav").trigger('to.owl.carousel', 0);
          } else{
            $('nav ul li a').removeClass('active');
          }
        });

        $('nav a[href*=#]:not([href=#])').click(function() {
          if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
              $('html,body').animate({
                scrollTop: target.offset().top
              }, 1000);
              return false;
            }
          }
        });

        $(window).on('resize', function(){
            if($(window).width() < 990){
                $(".careersNav").owlCarousel({
                  center:true,
                  loop:false,
                  autoplay: false,
                  margin:10,
                  autoWidth:true,
                    responsive : {
                      // [XS] breakpoint from 0 up
                      0 : {
                          items: 1,
                          loop: false,
                          nav:false,
                          dots:false
                      },
                      // [SM] breakpoint from 481 up
                      // 481 : {
                      //     items: 2,
                      //     loop: false,
                      //     nav:false,
                      //     dots:false
                      // },
                      // [MD] breakpoint from 768 up
                      768 : {
                          items: 2,
                          loop: false,
                          nav:false,
                          dots:false
                      },
                      // [MD] breakpoint from 992 up
                      992 : {
                          items: 4,
                          loop: false,
                          nav: false,
                          dots:false
                      },
                      // [LG] breakpoint from 1200 up
                      1200 : {
                          items: 8,
                          loop: false,
                          nav: false,
                          dots:false
                      }
                    }
                });
            }
        });
        $(window).trigger('resize');

        $(".gallery-carousel").owlCarousel({
          center: true,
          items:1,
          loop: true,
          margin:10,
          nav:false,
          dots:true,
          dotsEach:1,
          autoWidth:true,
          autoplay: true,
          autoplayTimeout: 8500,
            responsive : {
                // [XS] breakpoint from 0 up
                0 : {
                    items: 1,
                    loop: true,
                    nav:false
                },
                // [SM] breakpoint from 481 up
                481 : {
                    items: 2,
                    loop: true,
                    nav:false
                },
                // [MD] breakpoint from 768 up
                768 : {
                    items: 3,
                    loop: true,
                    nav:false
                },
                // [MD] breakpoint from 992 up
                992 : {
                    items: 4,
                    loop: true,
                    nav: false,
                },
                // [LG] breakpoint from 1200 up
                1200 : {
                    items: 5,
                    loop: true,
                    nav: false
                }
            },
          afterInit:function(){
            setTimout(function(){
              updateSize();
            },700);
          }
        });

        function updateSize(){
          var minHeight=parseInt($('.owl-item').eq(0).css('height'));
          $('.owl-item').each(function () {
              var thisHeight = parseInt($(this).css('height'));
              minHeight=(minHeight<=thisHeight?minHeight:thisHeight);
          });
          $('.owl-wrapper-outer').css('height',minHeight+'px');

          /*show the bottom part of the cropped images*/
          $('.owl-carousel .owl-item img').each(function(){
              var thisHeight = parseInt($(this).css('height'));
              if(thisHeight>minHeight){
                  $(this).css('margin-top',-1*(thisHeight-minHeight)+'px');
              }
          });
        }

      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'tax_recipe_category': {
      init: function() {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
